var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgActiveDriver = function SvgActiveDriver(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#EAE9F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2857 7.5H9.04762C7.98085 7.5 7.44747 7.5 7.04002 7.69679C6.68161 7.8699 6.39022 8.14611 6.20761 8.48585C6 8.87208 6 9.37768 6 10.3889V16.3472C6 17.3584 6 17.864 6.20761 18.2503C6.39022 18.59 6.68161 18.8662 7.04002 19.0393C7.44747 19.2361 7.98085 19.2361 9.04762 19.2361H19.3333V10.3889C19.3333 9.37768 19.3333 8.87208 19.1257 8.48585C18.9431 8.14611 18.6517 7.8699 18.2933 7.69679C17.8859 7.5 17.3525 7.5 16.2857 7.5Z",
    fill: "#696593"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7143 24.5139C13.0292 24.5139 14.0952 23.5034 14.0952 22.2569C14.0952 21.0105 13.0292 20 11.7143 20C10.3993 20 9.33333 21.0105 9.33333 22.2569C9.33333 23.5034 10.3993 24.5139 11.7143 24.5139Z",
    fill: "#696593"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 24.5139C23.9816 24.5139 25.0476 23.5034 25.0476 22.2569C25.0476 21.0105 23.9816 20 22.6667 20C21.3517 20 20.2857 21.0105 20.2857 22.2569C20.2857 23.5034 21.3517 24.5139 22.6667 24.5139Z",
    fill: "#696593"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5117 12.0139H20.2857V19.2361H24.4762C25.0096 19.2361 25.2763 19.2361 25.48 19.1377C25.6592 19.0512 25.8049 18.9131 25.8962 18.7432C26 18.5501 26 18.2973 26 17.7917V15.3205C26 15.0997 26 14.9893 25.9737 14.8854C25.9504 14.7933 25.9119 14.7052 25.8597 14.6245C25.8008 14.5334 25.7184 14.4553 25.5537 14.2992L23.5892 12.437C23.4245 12.2808 23.3421 12.2028 23.246 12.1469C23.1608 12.0974 23.0679 12.0609 22.9707 12.0388C22.8611 12.0139 22.7446 12.0139 22.5117 12.0139Z",
    fill: "#696593"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgActiveDriver);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "activeDriver.f05c7e8631217fa58f5e9e4052336b41.svg";